module.exports = __webpack_public_path__ + "media/icons/left-arrow-437e4e7b.png";